// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3AY2r","header":"ReportDetails_header__2Yt-q","title":"ReportDetails_title__2PUb1","left":"ReportDetails_left__ZU4Eq"};